import React, { useState, useEffect } from "react";
import { ENDPOINTS } from '@/config/endpoints';
import { useRouter } from 'next/router';
import Link from 'next/link';
import axios from 'axios';
import { pushCleverTapEvent } from "./pushCleverTapEvent";

const CategoryDropdown = () => {
  const [categories, setCategories] = useState([]);
  const [mWidth, setMWidth] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(() => {
    if (typeof window !== 'undefined') {
      // Initialize from localStorage, or default to null
      return parseInt(localStorage.getItem('selectedCategoryId')) || null;
    }
    return null;
  });
  const [industryCategories, setIndustryCategories] = useState([]);
  const router = useRouter();
  const { locale } = router;
  const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  }

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // const res = await axios.get(ENDPOINTS.WORDPRESS_ALL_CATEGORIES_API);
        const res = await axios.get(`${locale === 'es-mx'? ENDPOINTS.WORDPRESS_ALL_CATEGORIES_API_ES : ENDPOINTS.WORDPRESS_ALL_CATEGORIES_API}&lang=${locale === 'es-mx' ? 'es' : 'en'}`);
        // console.log('res',res.data)
        setCategories(res.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchCategories();

    handleWindowResize();
    window.addEventListener('load', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);

  }, [mWidth]);

   // Handle fetching industry categories
   useEffect(() => {
    const fetchIndustryCategories = async () => {
      try {
        const res = await axios.get(`${ENDPOINTS.WORDPRESS_ALL_CATEGORIES_API_INDUSTRY}&lang=en`);
        setIndustryCategories(res.data);
      } catch (error) {
        console.error('Error fetching industry categories:', error);
      }
    };
    fetchIndustryCategories();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Save selectedCategoryId to localStorage
      localStorage.setItem('selectedCategoryId', selectedCategoryId);
    }
  }, [selectedCategoryId]);

  useEffect(() => {
    // Extract category ID from the URL
    const { query } = router;
    if (query.id) {
      setSelectedCategoryId(parseInt(query.id));
    }

    else{
      setSelectedCategoryId(null);
    }
  }, [router.query]);

  const handleChange = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategoryId(selectedCategory);
    if (selectedCategory === 'all') {
      router.push('/blogs');
    } else {
      const category = categories.find(cat => cat.id === parseInt(selectedCategory));
    if (category) {
      router.push(`/blogs/category/${category.id}/${category.slug}`);
    } else {
      const filteredCategory = filteredCategories.find(cat => cat.id === parseInt(selectedCategory));

      if (filteredCategory) {
        router.push(`/blogs/category/${filteredCategory.id}/${filteredCategory.slug}`);
      }
    }
    }
  };

  const toTitleCase = (str) => {
    const exceptions = ['and']
    return str
    .split(' ')
    .map((word, index) => {
      if (index === 0 || !exceptions.includes(word.toLowerCase())) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join(' ');
  };
  const filteredCategories = industryCategories.filter(category => category.id !== 354);

  return (
    <>
      {categories && categories.length > 0 && mWidth < 767 && filteredCategories.length > 0 && (
        <select
          className='text-[12px] text-brand bg-[#fff] rounded-md py-[10px] px-[5px] w-full border border-brand h-[40px]'
          value={selectedCategoryId || 'default'} // Use value prop to set the selected value
          onChange={handleChange}>
          {locale == 'es-mx' ? <>
            <option value='default' disabled>Seleccione una categoría</option> {/* Use value 'default' */}
            <option value='all'>Todas las categorias</option>
          </> : <>
          <option value='default' disabled>Select a category</option> {/* Use value 'default' */}
          <option value='all'>All Categories</option>
          </>}
          {categories.filter((category) => category.id && category.name)
          .map(category => (
            <option key={category.id} value={category.id}>{category.name}</option>
          ))}

          {/* Industey specific Categories */}
         {locale === 'en-in' && <>
          <option value='default' disabled className="text-secondary font-bold">Industry</option> 
          {filteredCategories.map(category => (
           <option key={category.id} value={category.id}>{category.name}</option>
         ))}
         </>}
        </select>
      )}

      {categories && categories.length > 0 && mWidth > 767 && (
        <div className='bg-white shadow-icon-btn-shadow rounded-[15px] py-4 pb-4 px-2 sm:px-2 lg:w-full mx-auto md:relative md:m-auto md:mb-[20px]'>
          {locale == 'en-in' && <h2 className="text-xl mb-2 font-bold">Categories</h2>}
          {locale == 'es-mx' && <h2 className="text-xl mb-2 font-bold">Categorías</h2>}
          <ul>
            <li
              className={router.pathname == "/blogs" ? 'text-brand font-bold cursor-pointer mb-1' : 'cursor-pointer mb-1'}
              onClick={() => {
                setSelectedCategoryId(null);
                router.push('/blogs');
              }}>
                {locale == 'en-in' && <>All Categories</>}
                {locale == 'es-mx' && <>Todas las categorias</>}
            </li>
            {categories.map(category => (
              <li
                key={category.id}
                className={(selectedCategoryId === category.id ) ? 'text-brand font-bold cursor-pointer mb-1 whitespace-nowrap text-sm' : 'cursor-pointer mb-1 whitespace-nowrap text-sm'}
                onClick={() => {
                  setSelectedCategoryId(category.id);
                  router.push(`/blogs/category/${category.id}/${category.slug}`);
                 pushCleverTapEvent("Blog_Category",{"PageName": 'Blog_Page', "Category": category.slug, 'userProperties': 'last_blog_category_viewed'})
                }}
              >
                {toTitleCase(category.name)}
              </li>
            ))}

            {/* Industey specific Categories */}
            {locale == 'en-in' && <>
            <h2 className="text-xl mb-1 mt-2 font-bold">Industry</h2>
             {filteredCategories.map(category => (
              <li
                key={category.id}
                className={(selectedCategoryId === category.id ) ? 'text-brand font-bold cursor-pointer mb-1 whitespace-nowrap text-sm' : 'cursor-pointer mb-1 whitespace-nowrap text-sm'}
                onClick={() => {
                  setSelectedCategoryId(category.id);
                  router.push(`/blogs/category/${category.id}/${category.slug}`);
                  pushCleverTapEvent("Blog_Industry",{"PageName": 'Blog_Page', "Category": category.slug})
                }}
              >
                {toTitleCase(category.name)}
              </li>
            ))}
            </>}
          </ul>
        </div>
      )}
    </>
  );
};

export default CategoryDropdown;
